import React from 'react';

class ItemComment extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      name: 'Doanh nghiệp 1',
      address: 'address',
      time: '9:24 10/09/2017',
      tel: '+84 169 235 449',
      content: 'this is content'
    }
  }

  render() {
    return (
      <div className="item-comment-container">
        <div className='item-comment-header'>
          <div className='content-justify'>
            <p className='item-comment-business-name'>{this.state.name}</p>
            <p className='item-comment-business-desc'>{this.state.time}</p>
          </div>
          <div className='item-comment-business-address'>
            <span className='item-comment-business-desc mr25'>Địa chỉ:&nbsp;{this.state.address}</span>
            <span className='item-comment-business-desc'>Số điện thoại:&nbsp;{this.state.tel}</span>
          </div>
        </div>
        <div className='item-comment-content'>
          <p className='item-comment-business-desc'>{this.state.content}</p>
        </div>
      </div>
    );
  }
}

export default ItemComment;


// WEBPACK FOOTER //
// ./components/my-business/sub-view/need-offer/ItemComment.jsx